import { useState, useContext, useEffect } from 'react';
import { makeStyles } from '@material-ui/styles';
import { Modal, FilledInput, Typography, Button, FormGroup, FormLabel, FormControl, Box, Grid, TextField } from '@material-ui/core';
import Autocomplete from '@material-ui/lab/Autocomplete';

import themeColors from '../../assets/colors';
import { put } from '../../utils/api-services';
import helpers from '../../utils/helpers';
import AuthContext from '../../context';

const useStyles = makeStyles(() => ({
    root: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    container: {
        display: 'flex',
        flexDirection: 'column',
        backgroundColor: themeColors.background.default,
        padding: 20,
        width: '70%',
        borderRadius: 10
    },
    updateBtn: {
        marginLeft: 15,
        backgroundColor: '#0d6efd',
        borderColor: '#0d6efd',
        '&:hover': {
            backgroundColor: '#0d6efd',
            borderColor: '#0d6efd',
            boxShadow: 'none',
        }
    },
    bottom: {
        display: 'flex',
        alignSelf: 'flex-end',
    }
}));

const defSupervisor = { id: 0, name: 'Select a supervisor' };

const SupervisorUpdate = ({ open, employee, employees, onClose }) => {

    const classes = useStyles();
    const { showToast, signOut, showLoader } = useContext(AuthContext);
    const [state, setState] = useState({
        employees: [],
        employee: {},
        supervisor: defSupervisor
    });

    useEffect(() => {
        setState(prev => ({ ...prev, employee, employees }));
    }, [employee]);

    const handleChangeAutocomplete = (key, value) => setState(prev => ({ ...prev, [key]: value }));

    const validateForm = () => {
        if (!state.employee?.idemployee) {
            showToast('Employee not found', 'error');
        }

        store();
    }

    const store = async () => {
        showLoader(true);
        const response = await put(`/employee/${state.employee.idemployee}/updateSupervisor`, { supervisor: state.supervisor });
        if (response.status === 200) {
            showToast(response.message);
            setTimeout(() => window.location.reload(), 700);
        } else {
            console.log('[SupervisorUpdates] store error', response);
            helpers.failRequest(response, showToast, signOut);
        }
        showLoader(false);
    }

    return (
        <Modal
            open={open}
            onClose={onClose}
            className={classes.root}
        >
            <div className={classes.container}>
                <Typography variant='h2'>{'Update supervisor'}</Typography>
                <Grid container>
                    <Grid item sx={6}>
                        <FormGroup>
                            <FormLabel>{'Employee'}</FormLabel>
                            <FormControl
                                variant='filled'
                                component={Box}
                                width='100%'
                            >
                                <FilledInput
                                    disabled
                                    type='text'
                                    placeholder='Employee'
                                    value={state.employee?.name ?? ''}
                                />
                            </FormControl>
                        </FormGroup>
                    </Grid>
                    <Grid item xs={6}>
                        <FormGroup>
                            <FormLabel>{'Supervisor'}</FormLabel>
                            <Autocomplete
                                options={state.employees}
                                value={state.supervisor}
                                getOptionLabel={option => option?.name ?? ''}
                                getOptionSelected={(option, value) => option.idemployee === value.idemployee}
                                onChange={(e, value) => handleChangeAutocomplete('supervisor', value)}
                                renderInput={params => <TextField {...params} placeholder='Supervisor' />}
                            />
                        </FormGroup>
                    </Grid>
                </Grid>
                <div className={classes.bottom}>
                    <Button
                        variant='contained'
                        color='secondary'
                        onClick={onClose}
                    >
                        {'Cancel'}
                    </Button>
                    <Button
                        variant='contained'
                        className={classes.updateBtn}
                        onClick={validateForm}
                    >
                        {'Update'}
                    </Button>
                </div>
            </div>
        </Modal>
    );
}

export default SupervisorUpdate;